/**
 * @generated SignedSource<<3fe29e38e35e25a52080aa3172ea3b51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutHeaderBanner_viewer$data = {
  readonly disableEmailOnlyMakeOffer: boolean | null;
  readonly " $fragmentType": "CheckoutHeaderBanner_viewer";
};
export type CheckoutHeaderBanner_viewer$key = {
  readonly " $data"?: CheckoutHeaderBanner_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutHeaderBanner_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutHeaderBanner_viewer",
  "selections": [
    {
      "alias": "disableEmailOnlyMakeOffer",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disableEmailOnlyMakeOffer"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": "isEnabled(key:\"disableEmailOnlyMakeOffer\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "3376167829952c395748bf5e92258e0e";

export default node;
